import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import profile from '../../../global/img/profile.png';

// Latest Team News feed (fallback when no Twitter data)
const TeamNewsFeed = () => {
  const { latestTeamsNews = [], isLoading: loading, teamInfo } = useSelector((state) => state.teams);
  const error = null;
  const [visibleCount, setVisibleCount] = useState(3);
  const scrollRef = useRef(null);
console.log(teamInfo,'teamInfo')
  // Reset visible items when news changes
  useEffect(() => {
    setVisibleCount(3);
    if (scrollRef.current) scrollRef.current.scrollTop = 0;
  }, [latestTeamsNews]);

  const onScroll = (e) => {
    const target = e.currentTarget;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
      setVisibleCount((prev) => {
        const next = Math.min(prev + 3, latestTeamsNews.length || 0);
        return next;
      });
    }
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  // Show time ago for <24h, else show date
  const formatTimeAgoOrDate = (dateString) => {
    if (!dateString) return '';
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return '';
    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const minute = 60 * 1000;
    const hour = 60 * minute;
    const day = 24 * hour;
    if (diffMs < minute) return 'Just now';
    if (diffMs < hour) return `${Math.floor(diffMs / minute)}m ago`;
    if (diffMs < day) return `${Math.floor(diffMs / hour)}h ago`;
    return formatDate(dateString);
  };

  const getTeamFullName = () => {
    const sanitize = (v) => {
      if (v == null) return '';
      const s = String(v).trim();
      if (!s || s.toLowerCase() === 'null' || s.toLowerCase() === 'undefined') return '';
      return s;
    };
    const city = sanitize(teamInfo?.[0]?.team_city);
    const name = sanitize(teamInfo?.[0]?.team_name);
    const parts = [city, name].filter(Boolean);
    const full = parts.join(' ').trim();
    return full || 'Team';
  };

  return (
    <div className="news-column twitter-feed 888">
      <div className="news-header" style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, padding: '8px 0', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img src={teamInfo[0].team_logo !== "null" ? teamInfo[0].team_logo : teamInfo[0].team_logo_secondary}  alt="team logo" width="36" height="36" style={{ objectFit: 'contain' }} />
        {(() => {
          const fullName = getTeamFullName();
          const heading = fullName && fullName !== 'Team' ? `${fullName} — Latest News` : 'Latest News';
          return <h2 style={{ fontSize: '26px', margin: 0 }}>{heading}</h2>;
        })()}
      </div>
      <div
        className="tweet-scroll"
        style={{
          width: '650px',
          height: latestTeamsNews && latestTeamsNews.length > 0 ? '600px' : '100px',
          overflowY: latestTeamsNews && latestTeamsNews.length > 0 ? 'auto' : 'hidden'
        }}
        onScroll={onScroll}
        ref={scrollRef}
      >
        {latestTeamsNews && latestTeamsNews.length > 0 ? (
          latestTeamsNews.slice(0, visibleCount).map((news, idx) => {
            const newsKey = news.newsId || news.id || `${news.Url || 'news'}-${news.Updated || idx}`;
            const title = news.Title || 'Untitled';
            const source = news.Source || '';
            const updated = news.Updated ? formatTimeAgoOrDate(news.Updated) : '';
            const url = news.Url || '#';
            const author = news.Author || '';
            const categories = news.Categories || '';
            return (
              <div key={newsKey} className="news-post">
                <div className="post-profile">
                  <img
                    src={teamInfo[0].team_logo !== "null" ? teamInfo[0].team_logo : teamInfo[0].team_logo_secondary} 
                    alt="team"
                    width="50px"
                    style={{ objectFit: 'contain' }}
                  />
                </div>
                <div className="news-body">
                  <div className="post-header">
                    <p>
                      <strong className="username">{source}</strong>
                      <span className="postdate">{updated && ` · ${updated}`}</span>
                    </p>
                  </div>
                  <div className="post-body">
                    <p style={{ marginBottom: '6px', fontWeight: 600, color: '#0f1419' }}>
                      {title}
                    </p>
                    {news.Content && (
                      <p style={{ color: '#333' }}>{news.Content}</p>
                    )}
                    {categories && String(categories).trim() && (
                      <p style={{ color: '#777', fontSize: '12px', marginTop: '6px' }}>
                        Categories: {categories}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#8a8a8a',
            fontStyle: 'italic'
          }}>
            No recent team news available
          </div>
        )}
      </div>     
    </div>
  );
};

export default TeamNewsFeed;
